/* v49 · Precio único de la variante de bomba seleccionada. */
(function(){
  if(window.__b49PumpPriceInitialized)return;
  window.__b49PumpPriceInitialized=true;
  document.addEventListener('change',function(event){
    var select=event.target;
    if(!select||!select.matches||!select.matches('[data-b49-pump-select]'))return;
    var form=select.closest('.b49-pump-form');
    if(!form)return;
    var selected=select.options[select.selectedIndex];
    var price=form.querySelector('[data-b49-pump-price]');
    if(price&&selected&&selected.dataset.price){price.textContent=selected.dataset.price;}
  });
})();
